import { LoadingButton, type LoadingButtonProps } from './LoadingButton'

export const SmallLoadingButton = (props: LoadingButtonProps) => {
    return <LoadingButton size="small" {...props} />
}
